var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{staticClass:"text-right",attrs:{"md":"12"}},[_c('b-button',{staticClass:"text-gray",attrs:{"variant":"link"},on:{"click":_vm.logout}},[_vm._v(_vm._s(_vm.$t("logout"))+"\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }